
    import './styles.scoped.css';
    export default {
  "item-element": "awsui_item-element_93a1u_1tghn_99",
  "disabled": "awsui_disabled_93a1u_1tghn_111",
  "last": "awsui_last_93a1u_1tghn_118",
  "highlighted": "awsui_highlighted_93a1u_1tghn_121",
  "variant-icon": "awsui_variant-icon_93a1u_1tghn_125",
  "variant-inline-icon": "awsui_variant-inline-icon_93a1u_1tghn_125",
  "variant-normal": "awsui_variant-normal_93a1u_1tghn_125",
  "variant-primary": "awsui_variant-primary_93a1u_1tghn_125",
  "is-focused": "awsui_is-focused_93a1u_1tghn_138",
  "variant-navigation": "awsui_variant-navigation_93a1u_1tghn_142",
  "first": "awsui_first_93a1u_1tghn_145",
  "has-category-header": "awsui_has-category-header_93a1u_1tghn_145",
  "menu-item": "awsui_menu-item_93a1u_1tghn_158",
  "icon": "awsui_icon_93a1u_1tghn_176",
  "external-icon": "awsui_external-icon_93a1u_1tghn_181"
};
  